import React from 'react';
import { transparentize, darken } from 'polished';
import PropTypes from 'prop-types';
import { Editor } from '@tinymce/tinymce-react';
import styled from 'styled-components';
import config from 'utils/config';

const EditorWrapper = styled.div`
  display: block;
  width: 100%;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  & .rdw-editor-wrapper {
    display: block;
    width: 100%;
  }
  & .DraftEditor-editorContainer {
    width: 100%;
    background: #fff;
    padding: 30px;
    min-height: 160px;
    border-radius: 0 0 5px 5px;
    border: 1px solid ${transparentize(0.8, '#737384')};
    border-top: none;
    max-width: 840px;
  }
  & .rdw-editor-wrapper .rdw-editor-toolbar {
    display: grid;
    width: 100%;
    background: ${darken(0.1, '#737384')};
    border-radius: 2px 2px 0 0;
    padding: 5px;
    grid-template-columns: repeat(7, max-content);
    & .rdw-inline-wrapper {
      display: grid;
      grid-template-columns: repeat(7, 1fr);
    }
    & .rdw-list-wrapper,
    .rdw-text-align-wrapper {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
    }
    & .rdw-history-wrapper {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
    }
    & .rdw-block-wrapper,
    .rdw-fontsize-wrapper,
    .rdw-fontfamily-wrapper {
      display: inline-block;
      position: relative;

      & .rdw-dropdown-selectedtext {
        display: inline-flex;
        border: 1px solid rgba(255, 255, 255, 0.2);
        margin: 1px;
        width: 90px;
        height: 30px;
        align-items: center;
        padding: 0 30px 0 8px;
        position: relative;
        &:after {
          position: absolute;
          right: 10px;
          content: '\f107';
          color: #fff;
          top: 10px;
          font-size: 10px;
          font-family: 'flexibull-2-0';
        }
        & span {
          display: block;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #fff;
        }
      }
      & .rdw-dropdown-optionwrapper {
        position: absolute;
        top: 100%;
        left: 0;
        z-index: 100;
        border-radius: 2px;
        background: #fff;
        border: 1px solid ${(props) => props.theme.PrimaryBorderColor};
        list-style: none;
        margin: 0;
        max-height: 160px;
        overflow: scroll;
        padding: 0;
        white-space: nowrap;
        box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
        & li {
          min-width: 88px;
          padding: 8px 15px;
          cursor: pointer;
          margin: 2px 3px;
          border-radius: 2px;

          &.rdw-dropdownoption-active {
            background: ${transparentize(0.8, '#737384')};
          }
        }
      }
    }
  }
  & .rdw-option-wrapper {
    display: flex;
    width: 30px;
    height: 30px;
    /* border: 1px solid #ccc; */
    margin: 1px;
    border-radius: 2px;
    color: #fff;
    align-items: center;
    justify-content: center;
    opacity: 0.7;
    & img {
      filter: contrast(100) invert();
    }
    &.rdw-option-active {
      background: rgba(0, 0, 0, 0.3);
      opacity: 1;
    }
  }
`;

const RichTextEditor = (props) => (
  <EditorWrapper>
    <Editor
      init={{
        resize: false,
        height: props.height || 500,
        menubar: true,
        plugins: [
           'advlist','autolink','lists','link','image','charmap','preview','anchor',
           'searchreplace','visualblocks','fullscreen','insertdatetime','media',
           'table','wordcount','codesample','code','accordion','pagebreak'
        ],
        toolbar: 'undo redo | casechange blocks fontfamily fontsize bold italic underline accordion | strikethrough forecolor backcolor ' +
           'align lineheight bullist numlist outdent indent removeformat link image table media pagebreak code',
        file_browser_callback_types: 'image',
        file_picker_callback: function (cb, value, meta) {
          if (meta.filetype === 'image') {
            var input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.setAttribute('accept', 'image/*');
              input.click();
              input.onchange = function () {
                  var file = input.files[0];
                  var reader = new FileReader();
                  reader.onload = function (e) {
                    cb(e.target.result, {
                        alt: file.name
                    });
                  };
                  reader.readAsDataURL(file);
              };
          }
        },
        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
      }}
      apiKey={config.TINYMCE_KEY}
      value={props.value || ''}
      onEditorChange={(v) => props.handleChange(v)}
    />
  </EditorWrapper>
);

RichTextEditor.defaultProps = {
  height: '500',
};

RichTextEditor.propTypes = {
  value: PropTypes.any,
  height: PropTypes.string,
  handleChange: PropTypes.func,
};
export default RichTextEditor;
